import {
  TCreateLocationResponse,
  TLocationBoundaries,
  TLocationGeneralInfo,
} from 'shared/types'
import { api } from '..'

export const createLocation = (data: TLocationGeneralInfo) =>
  api
    .post<TCreateLocationResponse>('v1/locations', data)
    .then(({ data }) => data)

export const editLocationInfo =
  (locationId: string) => (data: TLocationGeneralInfo) =>
    api.put(`/v1/locations/${locationId}/information`, data)

export const editLocationBoundaries =
  (locationId?: string) => (boundaries: TLocationBoundaries) => {
    if (!locationId) throw new Error('Missing locationId')
    return api.put(`/v1/locations/${locationId}/boundaries`, boundaries)
  }
